import { useCallback, useEffect } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { LOYALTY_HOME_SCREEN } from '../../../../constants';
import { useTrackLoyaltyOnboardingModalNavigation } from '../../../../hooks';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * A custom hook that manages the referrer parameter for the Loyalty Home screen.
 */
export const useLoyaltyHomeScreenReferrer = () => {
  const params = useLocalSearchParams<LoyaltyHomeParams>();
  const router = useRouter();

  const isNavigatedFromOnboarding =
    params.referrer?.startsWith(LOYALTY_HOME_SCREEN.REFERRERS.ONBOARDING) ?? false;

  // ─── Helpers ─────────────────────────────────────────────────────────

  const removeReferrerParam = useCallback(() => {
    router.setParams({ referrer: undefined });
  }, [router]);

  const trackLoyaltyOnboardingModalNavigation = useTrackLoyaltyOnboardingModalNavigation({
    hasNavigated: isNavigatedFromOnboarding,
    onTrack: removeReferrerParam,
  });

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(trackLoyaltyOnboardingModalNavigation, [trackLoyaltyOnboardingModalNavigation]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type LoyaltyHomeParams = {
  referrer?: string;
};
